<div class="flex-fill d-flex flex-column">
    <div class="m-2 grid-fill" [ngStyle]="{ height: showAsDialog ? '600px' : '100%' }" *ngIf="parts">
        <dx-data-grid
            #partsGrid
            [dataSource]="parts"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="preferredVendor" width="200"></dxi-column>
            <dxi-column dataField="inStock" width="70"></dxi-column>
            <dxi-column dataField="onOrder" width="70" cellTemplate="poTemplate"></dxi-column>
            <dxi-column dataField="onBackOrder" width="70" cellTemplate="poTemplate"></dxi-column>
            <dxi-column dataField="category" width="150"></dxi-column>
            <dxi-column dataField="partNumber" width="210"></dxi-column>
            <dxi-column dataField="description" width="350"></dxi-column>

            <dxi-column dataField="cost" width="100" [format]="{ type: 'currency', precision: 4 }"></dxi-column>

            <dxi-column dataField="calculatedCost" width="100" [format]="{ type: 'currency', precision: 2 }" [visible]="showCosts" ></dxi-column>
            <dxi-column dataField="price" width="100" [format]="{ type: 'currency', precision: 4 }"></dxi-column>
            <dxi-column dataField="mfgPartNumber" width="100"></dxi-column>
            <dxi-column dataField="mfgDescription" width="100"></dxi-column>
            <div *dxTemplate="let cell of 'poTemplate'">
                <a [routerLink]="[]" (click)="purchaseOrderDialog(cell.data.id)">{{ cell.value || '' }}</a>
            </div>

            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel *ngIf="!showAsDialog" class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export *ngIf="!showAsDialog" [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-editing [mode]="'cell'" [allowUpdating]="false"></dxo-editing>
            <dxo-state-storing [enabled]="!showAsDialog" type="localStorage" storageKey="part-cost-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" (click)="toggleShowAll()" class="btn btn-sm btn-warning">
                    {{ showAll ? 'Hide Complient' : 'Show All' }}
                </button>
                <button type="button" (click)="toggleShowCostVsPrice()" class="btn btn-sm btn-info ms-2">
                    {{ showCosts ? 'Show By PRICE' : 'Show By COST' }}
                </button>

                <button type="button" (click)="refreshCalcCosts()" class="btn btn-sm btn-success ms-2" [hidden]="!showCosts" >Refresh Calculated Costs</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="parts" class="me-3"
                    ><strong
                        >{{ partsGrid.instance.totalCount() + ' items' }}
                        {{ partsGrid.instance.getSelectedRowsData().length > 0 ? partsGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
    <div>
        <dx-toast message="Changes Saved!" type="success" [displayTime]="500" [maxWidth]="300" [position]="'bottom right'" [(visible)]="isToastVisible"> </dx-toast>
    </div>
</div>
